export const HOME_URL = '/';
export const LOGIN_URL = '/login';
export const PARTICIPANT_SIGN_UP_URL = '/participant/signup';
export const PARTICIPANT_LOGIN = '/participant-login';
export const HOW_IT_WORKS = '/how-it-works';
export const DECIDE_ROLE = '/decide-role';
export const UNAUTHORIZED = '/unauthorized';
export const CERTIFIED_TRAINER = '/certified-trainer';
export const TRAINER_TTT_SIGN_UP = '/ttt-signup';

// ALL
export const DASHBOARD_URL = '/dashboard';
export const ADD_SESSION_URL = '/create-session';
export const SESSION_CREATED_URL = '/session-created/:id';
export const SURVEY_URL = '/survey/:id/:type';
export const SESSION_DETAILS_URL = '/session-details/:id';
export const MY_ACCOUNT_URL = '/my-account';
export const TRAINER_ADVICE_URL = '/trainer-advice';
export const MY_SESSIONS_URL = '/my-sessions';
export const ALL_SESSIONS_URL = '/all-sessions';
export const REGISTER_URL = '/register/:id';
export const TRAINER_PUBLIC_SESSIONS = '/available-sessions/:id';
export const COURSE_SCHEDULE = '/course-schedule';
export const CHOOSE_RESULTS_FOR_COURSE = '/choose-course';
export const CHOOSE_RESULTS_FOR_MATERIALS = '/choose-course-materials';

// trainer
export const TRAINER_RESULTS_URL = '/trainer-results';
export const TRAINER_SESSIONS_URL = '/trainer-sessions/trainerId?';
export const TRAINER_FEEDBACK_URL = '/feedback';
export const TRAINER_MANAGERS_GROUPS = '/trainer-managers-groups';
export const REMOVE_TRAINER_FROM_GROUP = '/remove/:localLead/:trainer';
export const CREATE_SESSION = '/create-session';
export const EVAL_RESULTS = '/survey/:id/:surveyType/results';
export const TRAINER_FILLED_TRAINER_SURVEY_SUCCESSFULLY =
  '/trainer/trainer-thank-you';

// local lead & admin
// for menu & navbar
export const MY_GROUP_RESULTS_URL = '/group-results/:course';
export const MY_GROUP_SESSIONS_URL = '/group-sessions';
// for App react router
export const GROUP_RESULTS_URL = `${MY_GROUP_RESULTS_URL}/:localLeadId?/:trainerName?`;
export const GROUP_SESSIONS_URL = `${MY_GROUP_SESSIONS_URL}/:localLeadId?`;
export const TRAINERS_URL = '/trainers';
export const PARTICIPANTS_URL = '/participants';
export const ADD_TRAINER_URL = '/add-trainer';
export const ADD_USER_URL = '/add-user';
// export const DECIDE_VIEW_URL = '/welcome-back';

// local lead
export const LOCAL_LEAD_SESSIONS_URL = '/localLead-sessions';

// admin
export const DEMOGRAPHICS_URL = '/demographics';

// participant
export const USER_INSIGHTS = '/my-insights';
export const USER_PROGRESS = '/my-progress';
export const USER_LOGIN = '/user-login';
export const USER_DASHBOARD = '/my-dashboard';
export const FORGET_PASSWORD = '/forget-password';
export const PARTICIPANT_DASHBOARD = '/participant-dashboard';
export const PARTICIPANT_SESSIONS_LIST = '/participant-sessions-list';
export const PARTICIPANT_SESSION_DETAILS = '/participant-session-details/:id';
export const PARTICIPANT_MATERIALS = '/participant/materials/:course';
export const PARTICIPANT_FILLED_SURVEY_SUCCESSFULLY = '/participant/thank-you';
export const CERTIFICATE = '/certificate/:id';
export const SIGN_UP_AFTER_FINISHING_TTT = '/ttt-signup';
